import type { ComparisonTableGroup } from '@ctct/payflow-ui';

import type { contentInternational } from './contentInternational';
import { dataComplianceGroup } from './dataComplianceGroup';

export const injectDataComplianceGroup = (groups: typeof contentInternational.groups): ComparisonTableGroup[] => {
  const additionalFeaturesIndex = groups.findIndex((group) => group.id === 'additionalFeatures');

  if (additionalFeaturesIndex === -1) {
    return [...groups, dataComplianceGroup];
  }

  return [...groups.slice(0, additionalFeaturesIndex), dataComplianceGroup, ...groups.slice(additionalFeaturesIndex)];
};
